// Takes a string and returns it with the first letter capitalized
export default function(str) {
	if (!str) return '';
	str = str.toString();
	return str.charAt(0).toUpperCase() + str.slice(1);
}
